module.exports = __webpack_public_path__ + "static/media/Skating.7826698d.jpg";